/**
 * 教师端 UI 主题集中配置（独立于学生端主题体系）
 * ============================================================
 * 与学生端的隔离约定（双侧互不影响）：
 *   - CSS 变量命名空间：--th-*（学生端为 --hud-*）
 *   - body class：theme-th-*（学生端为 theme-hud-*）
 *   - 本文件 / applyTeacherTheme.js / teacher-theme.css 均为教师端独立拷贝，
 *     不 import 学生端任何文件，后续可独立演进
 *   - 教师端专用 localStorage 键前缀：zhimingTeacher*
 *
 * 数据结构与学生端主题配置同形（token/路由/品牌三段）：
 * 未来后台 UI 管理下发换皮时，两端各自接入自己的引擎，互不牵连。
 *
 * token 语义键说明（清新教育标准型）：
 *   void          页面底色（浅蓝灰）      text          正文（深蓝灰）
 *   panel         卡片面（纯白）          textDim       次要文字（中性蓝灰）
 *   panelDeep     输入框/弹层填充底       textBright    标题文字
 *   panelHead     表头/条底               success       成功（苹果绿）
 *   primary       主色（苹果蓝）          danger        告警（苹果红）
 *   primaryRgb    主色RGB三元组（rgba 派生用，缺省由引擎从 primary 现算）
 *   primaryDeep   主色深（按压态）        accent        辅色（苹果橙强调）
 *   primaryBright 主色亮（链接/悬浮）     accentRgb     辅色RGB三元组
 *   onPrimary     主色实底之上的文字色
 *   hairline      发丝分隔线
 *   radiusCard/radiusInput/radiusPill  圆角标尺
 *   shadowCard    卡片柔和投影
 */
export const TEACHER_THEME_CONFIG = {
	version: 1,
	defaultTheme: 'th-fresh-education',

	/* 主题路由：先到先得（预留 corpId 客户维度；教师端暂无学段维度） */
	routes: [
		// { corpId: 10001, themeId: 'th-minimal-dark' },   // 示例：某客户定制
	],

	themes: {
		/* ---------- 默认：清新教育标准型 ---------- */
		'th-fresh-education': {
			themeId: 'th-fresh-education',
			name: '清新教育标准型',
			themeClass: 'theme-th-fresh-education',
			brand: {
				productName: '知明慧学 · 教师端',
				subName: 'TEACHER CONSOLE',
				logoUrl: ''
			},
			tokens: {
				void: '#F2F7FB',
				panel: '#ffffff',
				panelDeep: '#F6FAFD',
				panelHead: '#EAF5FB',
				primary: '#1F78B4',
				primaryRgb: '31, 120, 180',
				primaryDeep: '#17376F',
				primaryBright: '#2D8FD5',
				onPrimary: '#ffffff',
				accent: '#F4C95D',
				accentRgb: '244, 201, 93',
				success: '#48A77A',
				danger: '#D95C5C',
				text: '#1F2F46',
				textDim: '#65758B',
				textBright: '#17376F',
				hairline: '#DCEAF4',
				radiusCard: '22px',
				radiusInput: '14px',
				radiusPill: '980px',
				shadowCard: '0 12px 32px rgba(41, 104, 145, 0.08)'
			}
		}
	}
};

/* 全部主题 class（引擎切换前用于清除旧 class，防止多主题叠加） */
export const ALL_THEME_CLASSES = Object.values(TEACHER_THEME_CONFIG.themes).map(t => t.themeClass);
